<template>
  <generic-modal
    size="medium"
    :title="$t('enterprise')"
    icon="building"
    image="/images/icons/entity.png"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finish"
    :show_ok="show_ok"
    :show_cancel="show_cancel"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <div class="ui four item top attached tabular menu">
          <a class="active item" data-tab="general">
            <i class="info icon"></i> {{ $t("general") }}</a
          >
          <a class="item" data-tab="security">
            <i class="user tie icon"></i> {{ $t("super user") }}</a
          >
          <a class="item" data-tab="settings">
            <i class="settings icon"></i> {{ $t("settings") }}</a
          >
          <a class="item" data-tab="authentication">
            <i class="key icon"></i> {{ $t("authentication") }}</a
          >
        </div>
        <div class="ui bottom attached active tab segment" data-tab="general">
          <div
            class="two fields"
            v-bind:class="{
              disabled: enterprise && enterprise.status_code == 'D',
            }"
          >
            <div class="field">
              <label for>{{ $t("name") }}</label>
              <input type="text" name="name" v-model="enterprise_.name" />
            </div>
            <div class="field">
              <label for>{{ $t("codename") }}</label>
              <input
                type="text"
                name="codename"
                v-model="enterprise_.codename"
              />
            </div>
          </div>
          <div
            class="two fields"
            v-bind:class="{
              disabled: enterprise && enterprise.status_code == 'D',
            }"
          >
            <div class="field">
              <label for>{{ $t("status") }}</label>
              <div class="ui toggle checkbox">
                <input
                  type="checkbox"
                  name="status"
                  v-model="enterprise_.status"
                />
                <label>{{ $t("active") }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="ui bottom attached tab segment" data-tab="security">
          <h5 class="ui dividing header">{{ $t("super role") }}</h5>
          <div
            class="field"
            v-bind:class="{ disabled: enterprise_.enterprise_id }"
          >
            <label for>{{ $t("role name") }}</label>
            <input
              type="text"
              name="role_name"
              v-model="enterprise_.role_name"
            />
          </div>
          <h5 class="ui dividing header">{{ $t("super user") }}</h5>
          <div
            class="two fields"
            v-bind:class="{ disabled: enterprise_.enterprise_id }"
          >
            <div class="field">
              <label for>{{ $t("name") }}</label>
              <input
                type="text"
                name="name_of_user"
                v-model="enterprise_.name_of_user"
              />
            </div>
            <div class="field">
              <label for>{{ $t("username") }}</label>
              <input
                type="text"
                name="username"
                v-model="enterprise_.username"
              />
            </div>
          </div>
          <div
            class="two fields"
            v-bind:class="{ disabled: enterprise_.enterprise_id }"
          >
            <div class="field">
              <label for>{{ $t("password") }}</label>
              <input
                type="password"
                name="password"
                v-model="enterprise_.password"
              />
            </div>
            <div class="field">
              <label for>{{ $t("password confirmation") }}</label>
              <input
                type="password"
                name="repeat_password"
                v-model="enterprise_.repeat_password"
              />
            </div>
          </div>
        </div>
        <div class="ui bottom attached tab segment" data-tab="settings">
          <pre>{{ enterprise_.configuration }}</pre>
        </div>
        <div class="ui bottom attached tab segment" data-tab="authentication">
          <div class="field">
            <label for="">{{ $t("authentication method") }}</label>
            <div class="ui selection dropdown" ref="method_dropdown">
              <input type="hidden" name="ddwn" />
              <i class="dropdown icon"></i>
              <div class="default text"></div>
              <div class="menu"></div>
            </div>
          </div>
          <component
            :is="provider_component"
            @update="prov_setup_updated($event)"
            :setup_in="authentication.setup"
            ref="provider_comp"
          ></component>
        </div>
        <div class="ui error message"></div>
      </div>
      <div
        class="ui error icon message"
        v-if="enterprise && enterprise.status_code == 'D'"
      >
        <i class="dont icon"></i> {{ $t("deleted enterprise") }}
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, toast } from "@/utils";
import GenericModal from "@/components/GenericModal";
import ActiveDirectory from "./ActiveDirectory";
import Database from "./Database";
import LDAP from "./LDAP";
import sha1 from "js-sha1";

export default {
  name: "EnterpriseModal",
  components: {
    "generic-modal": GenericModal,
  },
  data() {
    return {
      processing: false,
      enterprise_: {},
      show_ok: true,
      show_cancel: true,
      form: undefined,
      authentication_methods: [
        {
          name: this.$t("modul"),
          value: "modul",
        },
        {
          name: this.$t("active directory"),
          value: "active_directory",
        },
        {
          name: this.$t("database"),
          value: "database",
        },
        {
          name: this.$t("ldap"),
          value: "ldap",
        },
      ],
      authentication: {
        method: "",
        setup: {},
      },
    };
  },
  computed: {
    provider_component() {
      if (this.authentication.method == "modul") return undefined;
      else if (this.authentication.method == "active_directory")
        return ActiveDirectory;
      else if (this.authentication.method == "database") return Database;
      else if (this.authentication.method == "ldap") return LDAP;
      else return undefined;
    },
  },
  props: {
    enterprise: Object,
  },
  mounted() {
    let vm = this;
    if (vm.enterprise.enterprise_id) {
      vm.processing = true;
      local_api(vm, "post", "/settings/enterprise/do-get", {
        u: vm.enterprise.uuid,
      })
        .then((response) => {
          if (response) {
            vm.enterprise_ = {
              role_name: response.role ? response.role.name : "¿?",
              username: response.user ? response.user.username : "¿?",
              name_of_user: response.user ? response.user.name : "¿?",
              password: "",
              codename: response.codename,
              name: response.name,
              status: response.status_code == "A",
              configuration: JSON.parse(response.configuration),
              enterprise_id: response.enterprise_id,
            };
            if (response.authentication) {
              vm.authentication = JSON.parse(response.authentication);
              if (vm.authentication.method) {
                window
                  .jQuery(vm.$refs.method_dropdown)
                  .dropdown("set selected", vm.authentication.method);
              }
            }

            if (response.status_code == "D") {
              vm.show_ok = false;
              vm.show_cancel = false;
            }

            // if (vm.enterprise_.login)
          }
        })
        .catch((err) => {
          toast(vm.$el, "error", err);
        })
        .finally(() => {
          this.processing = false;
        });
    } else
      this.enterprise_ = {
        role_name: "Super",
        username: "modul",
        name_of_user: "Enterprise Administrator",
        password: "",
        repeat_password: "",
        codename: "",
        name: "",
        status: true,
        configuration: {},
      };

    vm.form = window.jQuery(".ui.form").form({
      fields: {
        name: ["empty"],
        codename: ["empty"],
        role_name: ["empty"],
        username: ["empty"],
        password: ["empty"],
        repeat_password: ["empty", "match[password]"],
      },
    });

    window.jQuery(".ui.tabular.menu .item").tab();

    let vls = this.authentication_methods || [];
    window
      .jQuery(this.$refs.method_dropdown)
      .dropdown("setup menu", { values: vls })
      .dropdown({
        onChange(value) {
          vm.authentication.method = value;
          // if (value == "modul") {
          // } else if (value == "active_directory") {
          // } else if (value == "database") {
          // }
        },
      });
  },
  methods: {
    finish() {
      this.processing = true;
      let vm = this;
      let isValid = vm.form ? vm.form.form("validate form") : false;
      return new Promise(function(resolve, reject) {
        if (isValid) {
          local_api(vm, "post", "/settings/enterprise/do-save", {
            i: vm.enterprise_.enterprise_id,
            u: vm.enterprise_.codename,
            n: vm.enterprise_.name,
            s: vm.enterprise_.status ? "A" : "I",
            au: {
              rolename: vm.enterprise_.role_name,
              name_of_user: vm.enterprise_.name_of_user,
              username: vm.enterprise_.username,
              password: sha1(vm.enterprise_.password),
            },
            c: JSON.stringify(vm.enterprise_.configuration),
            a: JSON.stringify(vm.authentication),
          })
            .then((response) => {
              vm.$emit("succedded", response);
              resolve(response);
            })
            .catch((err) => {
              reject(err);
            })
            .finally(() => {
              vm.processing = false;
            });
        } else reject();
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    prov_setup_updated(setup) {
      this.authentication.setup = setup;
    },
  },
  watch: {},
  updated() {},
};
</script>

<style scoped>
.content .description {
  width: 100% !important;
}
</style>
